import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-227756e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(`
       wizard-container`)
}

import BrandPattern5 from "@/components/prospect/brandPattern/brandPattern5.vue";
import { Ref, computed, onMounted, ref, watch } from "vue";
import Modal from "@/components/common/modal.vue";
import ModalHeader from "@/components/common/modalHeader.vue";
import { getComponentUiText } from "@/utils/utilities";
import WizardWellcome from "./wizardWellcome.vue";
import WizardWrapper from "./wizardWrapper.vue";
import { INDEX_PRIMARY_PAGE, MODAL_NAME } from "@/utils/constants";
import { IModalMessage } from "@/interfaces/common/common";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import store from "@/store";
import { useRoute, useRouter } from "vue-router";
import { onUnmounted } from "vue";
import eventEmitter from "@/utils/eventEmitter";


export default /*#__PURE__*/_defineComponent({
  __name: 'setupWizardModal',
  props: {
  show: { type: Boolean, required: false },
},
  emits: ["update:show", "get-is-answered"],
  setup(__props, { emit }) {

const props = __props;




const isStatusApiSetup = computed(
  () => store.state.SetupWizard.isStatusApiSetup,
);

const route = useRoute();
const router = useRouter();
const stateActive: Ref<number> = ref(-1);
const activeComponent: Ref<number> = ref(-1);
const isAnswered: Ref<boolean> = ref(false);
const isPagesShown = ref(false);
let showRef = ref(props.show);

const isDirty = computed(() => {
  return store.getters["SetupWizard/isDirty"];
});

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
    if (value) getWizardGlobalData();
  },
);

onMounted(() => {
  getWizardGlobalData();
  EventEmitter.on(EmitterEvents.CLOSE_MODAL, closeModal);
  const queryValue = route.query?.type;
  if (queryValue && isStatusApiSetup.value) {
    setTimeout(() => showContent(0), 200);
  }
});

watch(
  () => isStatusApiSetup.value,
  (value) => {
    const queryValue = route.query?.type;
    if (queryValue && value) {
      setTimeout(() => showContent(0), 200);
    }
  },
);

onUnmounted(() => {
  EventEmitter.off(EmitterEvents.CLOSE_MODAL, closeModal);
});

const closeModal = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
};

const handleCloseModal = () => {
  if (!isDirty.value) {
    // not changing, redirect to home
    eventEmitter.emit(
      EmitterEvents.SET_PRIMARY_MENU_INDEX,
      INDEX_PRIMARY_PAGE.home,
    );
    return router.push({ path: "/" });
  }

  // changing, show modal
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_WIZARD_SAVE_EXIT,
    properties: {
      isMoreInfoModal: true,
      isAnswered: isAnswered.value,
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);

  // showRef.value = false;
  // emit("update:show", showRef.value);
};

const getWizardGlobalData = () => {
  store.commit("SetupWizard/SET_STATE_API_SETUP", false);
  store.dispatch("SetupWizard/fetchQuestion");
};

const showContent = async (state: number) => {
  stateActive.value = state;
  await new Promise((resolve) => setTimeout(resolve, 510));
  isPagesShown.value = true;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    class: "!tw-top-[155px] !tw-translate-y-0 wizard-setup-modal tw-max-w-[1263px] !tw-z-[1070]",
    visible: _unref(showRef),
    "overflow-y-visible": true,
    "border-radius": "4px",
    "close-on-backdrop-click": true,
    onClose: handleCloseModal
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        style: {"z-index":"10"},
        class: _normalizeClass(`modal-header tw-bg-[#FFFFFF]`),
        title: 
        _unref(getComponentUiText)('app-menu-submenu-home-setup-wizard-modal-title-1')
      ,
        onClose: handleCloseModal
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(BrandPattern5, {
          class: "!tw-top-0 !tw-h-full",
          page: "APPBARLAYOUT"
        }),
        _createElementVNode("div", {
          class: _normalizeClass([
          stateActive.value !== -1 ? 'show' : '',
          'tw-flex tw-bg-transparent wizard-content',
        ])
        }, [
          _createVNode(WizardWellcome, {
            class: _normalizeClass(`tw-w-[50%] tw-z-[1] ${isPagesShown.value ? 'tw-opacity-0' : ''}`),
            "onUpdate:state": _cache[0] || (_cache[0] = ($event: any) => (showContent(0)))
          }, null, 8, ["class"]),
          _createVNode(WizardWrapper, {
            class: _normalizeClass(['tw-w-[50%]']),
            "show-state-component": stateActive.value,
            "is-status-api-setup-ready": isStatusApiSetup.value,
            "onUpdate:activeComponent": _cache[1] || (_cache[1] = (value) => (activeComponent.value = value)),
            onGetIsAnswered: _cache[2] || (_cache[2] = (value) => (isAnswered.value = value))
          }, null, 8, ["show-state-component", "is-status-api-setup-ready"])
        ], 2)
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})